/** 规划第三阶段 P3-5（计划 P3-5b）：案件页上的图纸检查工具、设置中的约束图层、这些工具的拒绝说明及其日志类型名称。并入 zh.ts。 */

import rulesStrings from './rules-zh'

export default {
  intake: {
    rules: rulesStrings.rules,
    title: '图纸检查工具',
    applicantTitle: '图纸检查',
    accept: {
      button: '附例外接受',
      title: '附例外接受未通过的检查',
      intro: '此检查仅因官员可接受的发现而未通过。接受后，此版本的登记行将进入暂存，并生成更正后的图纸数据副本。',
      findings: '接受的发现',
      noFindings: '没有列出可接受的发现。请先重新加载页面再接受。',
      reason: '理由',
      reasonHint: '仅供官员查看。申请人只会看到检查已被接受，不会看到此理由或这些发现。',
      reasonRequired: '请填写理由。',
      confirm: '接受',
      cancel: '取消',
      done: '已附例外接受该检查。',
    },
    acceptances: {
      title: '已接受的检查',
      item: '版本 {{revision}}，于 {{date}} 接受',
      exceptions: '接受的发现：{{codes}}',
      applicant: '市政局已于 {{date}} 接受版本 {{revision}} 的图纸检查。',
    },
    corrections: {
      title: '类别更正',
      item: '{{row}}：由 {{from}} 改为 {{to}}',
      when: '版本 {{revision}}，于 {{date}} 更正',
    },
    rows: {
      title: '登记行',
      intro: '此版本的场地和地块在登记中的记录。',
      site: '场地',
      plot: '地块 {{number}}',
      plotRow: '地块（登记行 {{id}}）',
      noClass: '无类别',
      status: {
        candidate: '候选（未暂存）',
        staging: '暂存（等待决定）',
        approved: '已批准',
        rejected: '已拒绝',
        superseded: '已被取代',
        withdrawn: '已撤回',
      },
      source: {
        drawing: '来自图纸',
        officer: '由官员更正',
      },
      showOnMap: '在地图上显示',
      correct: '更正类别',
      olderRevision: '只能在当前版本上更正类别。',
    },
    correct: {
      title: '更正{{row}}的类别',
      current: '当前类别：{{class}}',
      class: '新类别',
      choose: '选择类别…',
      classRequired: '请选择一个类别。',
      unchanged: '请选择与当前不同的类别。',
      reason: '理由',
      reasonHint: '仅供官员查看；申请人看不到。',
      reasonRequired: '请填写理由。',
      confirm: '保存类别',
      cancel: '取消',
      done: '类别已更正。',
    },
    constraints: {
      title: '约束检查',
      advisory: '仅供参考：以下重叠供官员参考，决定仍由官员作出。',
      none: '此提交尚未进行约束检查。',
      run: '运行约束检查',
      rerun: '重新运行检查',
      requested: '已请求检查。报告完成后会显示在这里。',
      queued: '约束检查正在等待运行…',
      running: '约束检查正在运行…',
      failed: '约束检查未能完成：{{reason}}',
      newer: {
        queued: '版本 {{revision}} 的较新检查正在等待运行。完成后其报告将取代此报告。',
        running: '版本 {{revision}} 的较新检查正在运行。完成后其报告将取代此报告。',
        failed: '版本 {{revision}} 的较新检查未能完成：{{reason}}下方的报告仍然有效。',
      },
      meta: '版本 {{revision}}，于 {{date}} 检查',
      packVersion: '数据包版本 {{version}} 的约束类型',
      older: '此报告属于版本 {{revision}}；当前版本为 {{current}}。',
      trigger: {
        staged: '暂存后运行',
        on_demand: '由官员运行',
      },
      noFindings: '没有检查任何约束图层。',
      layer: '图层：{{name}}',
      status: {
        overlap: '有重叠',
        clear: '无重叠',
        error: '无法检查',
      },
      overlap: '{{area}}（占场地的 {{pct}}%）',
      features: '重叠要素：{{number}}',
      needsDetermination: '需要裁定',
      determinations: {
        title: '官员裁定',
        open: '决定前仍需的裁定：{{number}}',
        pending: '尚未裁定',
        recorded: '{{outcome}}（{{date}} 裁定）',
        note: '备注：{{note}}',
        record: '记录裁定',
        change: '更改裁定',
      },
      determine: {
        title: '裁定：{{kind}}',
        intro: '在作出决定前，记录官员对此约束的裁定。',
        outcome: '结果',
        note: '备注',
        noteHint: '可选。官员和市政局部门可以看到；申请人看不到。',
        replaces: '这将取代 {{date}} 记录的裁定。',
        outcomeRequired: '请选择一个结果。',
        confirm: '记录',
        cancel: '取消',
        done: '裁定已记录。',
      },
      outcomes: {
        not_affected: '不受影响',
        acceptable: '可接受',
        objection: '反对',
      },
      kinds: {
        hutan_simpan: '永久森林保护区',
        ksas_tahap_1: '一级环境敏感区',
        ksas_tahap_2: '二级环境敏感区',
        rizab_sungai: '河流保留地',
        rizab_jalan: '道路保留地',
        kawasan_banjir: '易淹水地区',
      },
      findingErrors: {
        layer_missing: '绑定的图层已不在资源库中。',
        layer_unsupported: '绑定的图层不是 PostgreSQL 或 ArcGIS 要素图层。',
        server_unavailable: '无法连接图层的服务器。',
        layer_srid_unknown: '图层的坐标系未知。',
        query_failed: '无法查询该图层。',
        too_many_features: '与场地重叠的要素过多，无法统计。',
        address_blocked: '该图层的地址不被允许。',
        other: '无法检查该图层。',
      },
      reportErrors: {
        site_missing: '登记中没有此版本的场地。',
        superseded: '已被更新的报告取代。',
        run_failed: '检查因错误而停止。',
        other: '检查已停止。',
      },
    },
    settings: {
      title: '约束图层',
      description:
        '将数据包的每种约束类型绑定到描绘该约束的资源库图层。检查在登记暂存后以及官员请求时运行，结果仅供参考。',
      kindsVersion: '数据包版本 {{version}} 的约束类型。',
      determination: '需要官员裁定',
      advisory: '仅供参考',
      none: '尚未绑定图层。',
      add: '添加',
      addLabel: '要绑定到{{kind}}的图层',
      choose: '选择图层…',
      remove: '移除',
      removeLabel: '从{{kind}}移除{{layer}}',
      missingLayer: '已不可用的图层（{{id}}）',
      unlistedLayer: '图层 {{id}}',
      loading: '正在加载资源库图层…',
      loadFailed: '无法加载资源库图层。',
      capped: '每种类型仅列出前 {{max}} 个图层。',
      noLayers: '资源库中没有可绑定的 PostgreSQL 或 ArcGIS 要素图层。',
      types: {
        postgresql: 'PostgreSQL 图层',
        arcgis_feature: 'ArcGIS FeatureServer 图层',
      },
      count: '已使用 {{used}} / {{max}} 个绑定',
      tooMany: '最多 {{max}} 个绑定。',
      repeated: '同一图层被两次绑定到同一类型。',
      unknownKind: '请移除数据包已不再声明的类型的绑定。',
      undeclared: '数据包已不再声明的类型',
    },
  },
  errors: {
    ...rulesStrings.errors,
    check_not_acceptable: '此图纸检查无法接受：它已通过、已被接受，或因比例或市政局辖区而未通过。',
    register_row_not_found: '该登记行不在此提交的当前版本中。',
    class_row_changed: '页面加载后该登记行已更改。请重新加载页面后重试。',
    class_row_not_staged: '只能更正当前版本中处于暂存状态的登记行。',
    class_path_invalid: '该类别不属于此提交的土地用途类别。',
    class_unchanged: '该行已是此类别。',
    constraints_not_configured: '尚未绑定约束图层。管理员可在“设置 → 规划”中绑定。',
    register_rows_missing: '当前版本没有可检查的登记行。',
    constraint_report_not_found: '该约束报告不属于此案件。',
    constraint_report_not_done: '该约束报告尚未完成。请重新加载页面后重试。',
    constraint_report_superseded: '该约束报告已被更新的报告取代。请重新加载页面后重试。',
    constraint_kind_unknown: '此报告中的该约束类型无需裁定。',
    constraint_report_changed: '页面加载后该约束报告已更改。请重新加载页面后重试。',
  },
  events: {
    plot_class_corrected: '登记类别已更正',
    constraints_checked: '已记录约束检查',
    rules_evaluated: '已评估规划规则',
    letter_issued: '已签发决定函',
    letter_signed: '已验证已签署的决定函',
    // D-234：接受转换本身的事件，与其后的接受事件一样以中性措辞标注。
    transition_check_accept_exceptions: '图纸检查已接受',
  },
} as const
